import ReglasForm from "./ReglasForm";
export default ReglasForm;